<template>
    <li class="dd-m-menu__item">
    

        <!--a class="dd-m-menu__link" v-on:click.prevent="show" title="privacy policy"-->
        <a class="dd-m-menu__link" target="_blank" href="https://www.avon.ph/avon-ph/privacy-policy.html" title="privacy policy">
            <i class="dd-m-icon icon-shield-user"></i>
            <span>privacy policy</span>
        </a>
    </li>
</template>

<script>
    export default {
        name: "privacy-policy-item",
        methods: {
            show() {
                PubSub.publish('togglePrivacyModal', true);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/pages/privacy-policy/privacy-policy-item.vue